import api from './api';

class CouponService {
	async getById(id) {
		return api
			.get(`/coupons/${id}`)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					`fail when trying to get coupon with id ${id} in CouponService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getByCode(code) {
		return api
			.patch(`/coupons/${code}`)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					`fail when trying to get coupon with code ${code} in CouponService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async create(couponForm) {
		return api
			.post('/coupons', couponForm)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to create coupon in CouponService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async getAllCoupons(params) {
		return api
			.get('/coupons', { params })
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to get coupons in CouponService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async remove(id) {
		return api
			.delete(`/coupons/${id}`)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to remove coupon in CouponService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async update(id, couponForm) {
		console.log('updateClient', id, couponForm);
		return api
			.put(`/coupons/${id}`, couponForm)
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to update coupon in CouponService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async hasCouponWithCode(code, couponId) {
		return api
			.head(`/coupons/exists/${code}/${couponId}`)
			.then((response) => true)
			.catch((error) => {
				if (error.response?.status === 404) {
					return false;
				}
				console.log(
					`fail when trying to check if coupon with code ${code} exists in CouponService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}
}

const couponService = new CouponService();
export default couponService;
